import React from 'react';

function SermonPage({ onBack }) {
  const sermonUrl = "https://chatgpt.com/g/g-679fc9af9c4481919f26c15c41e9813e-sermon-en-main";

  // Ouvrir directement dans un nouvel onglet au chargement
  React.useEffect(() => {
    window.open(sermonUrl, '_blank', 'noopener,noreferrer');
    // Retour automatique après 1 seconde
    setTimeout(() => {
      onBack();
    }, 1000);
  }, [sermonUrl, onBack]);

  return (
    <div className="sub-page">
      <div className="sub-header">
        <button className="sub-back" onClick={onBack}>← Retour</button>
        <div className="sub-header-center">
          <div className="sub-title">Sermon en Main</div>
          <div className="sub-sub">Redirection en cours...</div>
        </div>
      </div>
      <div className="sub-body">
        <div className="sub-content">
          <div className="sub-empty">
            <div className="empty-icon">🎤</div>
            <h3>Ouverture de Sermon en Main...</h3>
            <p>L'outil s'ouvre dans un nouvel onglet. Vous serez redirigé automatiquement.</p>
            <button className="sub-btn primary" onClick={onBack}>← Retour à l'accueil</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SermonPage;
